class AnchorLinks extends HHBaseElement {
  constructor() {
    super()

    this.mainMenu = document.querySelector('main-menu')
    this.$links = [...this.querySelectorAll('a.anchor-link')].filter(link => link.getAttribute('href').includes('#') == true)

    this._doClickLink = this._doClickLink.bind(this)
  }

  connectedCallback() {
    this._attachListeners()
  }

  disconnectedCallback() {
    this._removeListeners()
  }

  _attachListeners() {
    if(this.$links.length) {
      this.$links.forEach((item) => {
        item.addEventListener('click', (event) => this._doClickLink(event, item))
      })
    }
  }

  _removeListeners() {
    if(this.$links) {
      this.$links.forEach((item) => {
        item.removeEventListener('click', (event) => this._doClickLink(event, item))
      })
    }
  }

  _doClickLink(event, link) {
    event.preventDefault()

    const targetId = link.getAttribute('href').split('#')[1]
    const targetElement = document.querySelector(`#${targetId}`)
    if(targetElement) {
      const { height } = this.mainMenu.getBoundingClientRect()
      const scrollTop = targetElement.offsetTop - height
      window.scrollTo({
        top: scrollTop,
        behavior: 'smooth'
      })
    }
  }
}

window.customElements.define('hh-anchor-links', AnchorLinks)
